/** BE connectionState values from GET /api/supplier-search (dl-61824). */
export const SupplierConnectionStates = {
  Available: 'available',
  AlreadyConnected: 'already_connected',
  ConnectedInactive: 'connected_inactive',
  RequestPending: 'request_pending',
  MergeInProgress: 'merge_in_progress',
  OnClassicPlatform: 'on_classic_platform',
} as const;

export type SupplierConnectionState =
  (typeof SupplierConnectionStates)[keyof typeof SupplierConnectionStates];

export const SupplierConnectionRequestTypes = {
  NetNewInvite: 'NetNewInvite',
  ConnectExistingPortal: 'ConnectExistingPortal',
} as const;

export type SupplierConnectionRequestType =
  (typeof SupplierConnectionRequestTypes)[keyof typeof SupplierConnectionRequestTypes];

export type SupplierSearchResult = {
  id: string;
  companyName: string;
  connectionState: SupplierConnectionState;
  selectable: boolean;
  /**
   * Present when connectionState is request_pending and resend is available.
   * Live BE search (dl-61824) does not yet return this — Resend stays Mirage/demo-only
   * until the search DTO includes it (or pending-list FE dl-61986 lands).
   */
  pendingConnectionId?: string | null;
  email?: string | null;
  /** BE `AvatarColor` (dl-61824). NULL today, so Avatar falls back to its initials hash. */
  avatarColor?: string | null;
  inviteCode?: string | null;
};

/** Live BE body for POST /api/supplier-connections (dl-61833). */
export type NetNewInviteRequest = {
  inviteEmail: string;
};

/** Live BE body for POST /api/supplier-connections (dl-62112 / Flow 4). */
export type ConnectExistingPortalRequest = {
  requestType: typeof SupplierConnectionRequestTypes.ConnectExistingPortal;
  supplierOrgId: number | string;
  message?: string;
};

export type CreateSupplierConnectionRequest = NetNewInviteRequest | ConnectExistingPortalRequest;

/**
 * Create response from POST /api/supplier-connections — already shaped as a Pending
 * connections row so the FE can render it immediately (pending list HTTP is dl-61986).
 */
export type CreateSupplierConnectionResponse = {
  id: string;
  companyName: string | null;
  email: string;
  invitedBy: string;
  dateSent: string;
  status: 'Pending' | string;
};
